export const BUTTON_CONST = {
  detail: '상세보기',
  search: '검색',
  lookUp: '조회하기',
  edit: '수정하기',
  editShort: '수정',
  save: '저장',
  close: '닫기',
  apply: '적용',
  cancel: '취소',
  ok: '확인',
  backToList: '목록으로 돌아가기',
  backToScreen: '이전 화면',
  backToPrevious: '이전으로 돌아가기',
  login: '로그인',
  logout: '로그아웃',
  later: '취소',
  changePassword: '비밀번호 변경',
  preview: '미리보기',
  resetPassword: '비밀번호 재설정',
  view: '보기',
  delete: '삭제',
  detailView: '상세보기',
  downloadExcel: '엑셀 다운로드',
} as const;
